"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Papybase = void 0;
const axios_1 = __importDefault(require("axios"));
const goal_1 = require("..//extra/goal");
const industry_1 = require("..//extra/industry");
const source_1 = require("..//extra/source");
const auth_1 = require("../auth/auth");
const certificate_1 = require("../certificate/certificate");
const forward_1 = require("../forward/forward");
const geoip_1 = require("../geoip/geoip");
const merchant_1 = require("../merchant/merchant");
const order_1 = require("../order/order");
const product_1 = require("../product/product");
const transaction_1 = require("../transaction/transaction");
const upload_1 = require("../upload/upload");
const user_1 = require("../user/user");
const uuid_1 = require("../uuid/uuid");
const personnel_1 = require("./../personnel/personnel");
class Papybase {
    constructor(instance) {
        this.instance = instance;
    }
    static initializeApp(instanceConfig) {
        const instance = axios_1.default.create(instanceConfig);
        return new Papybase(instance);
    }
    auth() {
        return new auth_1.Auth(this.instance);
    }
    user() {
        return new user_1.User(this.instance);
    }
    forward() {
        return new forward_1.Forward(this.instance);
    }
    product() {
        return new product_1.Product(this.instance);
    }
    personnel() {
        return new personnel_1.Personnel(this.instance);
    }
    certificate() {
        return new certificate_1.Certificate(this.instance);
    }
    merchant() {
        return new merchant_1.Merchant(this.instance);
    }
    upload() {
        return new upload_1.Upload(this.instance);
    }
    transaction() {
        return new transaction_1.Transaction(this.instance);
    }
    industry() {
        return new industry_1.Industry(this.instance);
    }
    goal() {
        return new goal_1.Goal(this.instance);
    }
    source() {
        return new source_1.Source(this.instance);
    }
    geoIP() {
        return new geoip_1.GeoIP(this.instance);
    }
    order() {
        return new order_1.Order(this.instance);
    }
    uuid() {
        return new uuid_1.UUID(this.instance);
    }
}
exports.Papybase = Papybase;
//# sourceMappingURL=app.js.map